import React from 'react'
import PropTypes from 'prop-types'

const PATH = 'M7.5 15C7.04167 15 6.64931 14.8368 6.32292 14.5104C5.99653 14.184 5.83333 13.7917 5.83333 '
  + '13.3333V3.33333C5.83333 2.875 5.99653 2.48264 6.32292 2.15625C6.64931 1.82986 7.04167 1.66'
  + '667 7.5 1.66667H15C15.4583 1.66667 15.8507 1.82986 16.1771 2.15625C16.5035 2.48264 16.6667'
  + ' 2.875 16.6667 3.33333V13.3333C16.6667 13.7917 16.5035 14.184 16.1771 14.5104C15.8507 14.8'
  + '368 15.4583 15 15 15H7.5ZM7.5 13.3333H15V3.33333H7.5V13.3333ZM2.73958 6.42708C2.57986 6.26'
  + '736 2.5 6.06944 2.5 5.83333C2.5 5.59722 2.57986 5.3993 2.73958 5.23958C2.89931 5.07986 3.0'
  + '9722 5 3.33333 5C3.56944 5 3.76736 5.07986 3.92708 5.23958C4.08681 5.3993 4.16667 5.59722 '
  + '4.16667 5.83333C4.16667 6.06944 4.08681 6.26736 3.92708 6.42708C3.76736 6.5868 3.56944 6.6'
  + '6667 3.33333 6.66667C3.09722 6.66667 2.89931 6.5868 2.73958 6.42708ZM2.73958 9.34375C2.579'
  + '86 9.18403 2.5 8.98611 2.5 8.75C2.5 8.51389 2.57986 8.31597 2.73958 8.15625C2.89931 7.9965'
  + '3 3.09722 7.91667 3.33333 7.91667C3.56944 7.91667 3.76736 7.99653 3.92708 8.15625C4.08681 '
  + '8.31597 4.16667 8.51389 4.16667 8.75C4.16667 8.98611 4.08681 9.18403 3.92708 9.34375C3.767'
  + '36 9.50347 3.56944 9.58333 3.33333 9.58333C3.09722 9.58333 2.89931 9.50347 2.73958 9.34375'
  + 'ZM2.73958 12.2604C2.57986 12.1007 2.5 11.9028 2.5 11.6667C2.5 11.4306 2.57986 11.2326 2.73'
  + '958 11.0729C2.89931 10.9132 3.09722 10.8333 3.33333 10.8333C3.56944 10.8333 3.76736 10.913'
  + '2 3.92708 11.0729C4.08681 11.2326 4.16667 11.4306 4.16667 11.6667C4.16667 11.9028 4.08681 '
  + '12.1007 3.92708 12.2604C3.76736 12.4201 3.56944 12.5 3.33333 12.5C3.09722 12.5 2.89931 12.'
  + '4201 2.73958 12.2604ZM2.73958 15.1771C2.57986 15.0174 2.5 14.8194 2.5 14.5833C2.5 14.3472 '
  + '2.57986 14.1493 2.73958 13.9896C2.89931 13.8299 3.09722 13.75 3.33333 13.75C3.56944 13.75 '
  + '3.76736 13.8299 3.92708 13.9896C4.08681 14.1493 4.16667 14.3472 4.16667 14.5833C4.16667 14'
  + '.8194 4.08681 15.0174 3.92708 15.1771C3.76736 15.3368 3.56944 15.4167 3.33333 15.4167C3.09'
  + '722 15.4167 2.89931 15.3368 2.73958 15.1771ZM2.73958 18.0937C2.57986 17.934 2.5 17.7361 2.'
  + '5 17.5C2.5 17.2639 2.57986 17.066 2.73958 16.9062C2.89931 16.7465 3.09722 16.6667 3.33333 '
  + '16.6667C3.56944 16.6667 3.76736 16.7465 3.92708 16.9062C4.08681 17.066 4.16667 17.2639 4.1'
  + '6667 17.5C4.16667 17.7361 4.08681 17.934 3.92708 18.0937C3.76736 18.2535 3.56944 18.3333 3'
  + '.33333 18.3333C3.09722 18.3333 2.89931 18.2535 2.73958 18.0937ZM5.65625 18.0937C5.49653 17'
  + '.934 5.41667 17.7361 5.41667 17.5C5.41667 17.2639 5.49653 17.066 5.65625 16.9062C5.81597 1'
  + '6.7465 6.01389 16.6667 6.25 16.6667C6.48611 16.6667 6.68403 16.7465 6.84375 16.9062C7.0034'
  + '7 17.066 7.08333 17.2639 7.08333 17.5C7.08333 17.7361 7.00347 17.934 6.84375 18.0937C6.684'
  + '03 18.2535 6.48611 18.3333 6.25 18.3333C6.01389 18.3333 5.81597 18.2535 5.65625 18.0937ZM8'
  + '.57292 18.0937C8.41319 17.934 8.33333 17.7361 8.33333 17.5C8.33333 17.2639 8.41319 17.066 '
  + '8.57292 16.9062C8.73264 16.7465 8.93056 16.6667 9.16667 16.6667C9.40278 16.6667 9.60069 16'
  + '.7465 9.76042 16.9062C9.92014 17.066 10 17.2639 10 17.5C10 17.7361 9.92014 17.934 9.76042 '
  + '18.0937C9.60069 18.2535 9.40278 18.3333 9.16667 18.3333C8.93056 18.3333 8.73264 18.2535 8.'
  + '57292 18.0937ZM11.4896 18.0937C11.3299 17.934 11.25 17.7361 11.25 17.5C11.25 17.2639 11.32'
  + '99 17.066 11.4896 16.9062C11.6493 16.7465 11.8472 16.6667 12.0833 16.6667C12.3194 16.6667 '
  + '12.5174 16.7465 12.6771 16.9062C12.8368 17.066 12.9167 17.2639 12.9167 17.5C12.9167 17.736'
  + '1 12.8368 17.934 12.6771 18.0937C12.5174 18.2535 12.3194 18.3333 12.0833 18.3333C11.8472 1'
  + '8.3333 11.6493 18.2535 11.4896 18.0937Z'

const DuplicateIcon = ({ className, title, onClick }) => (
  <svg
    className={`tw:inline-block tw:align-middle ${className}`.trim()}
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    role="img"
    aria-label={title}
    onClick={onClick}
  >
    <path d={PATH} fill="currentColor" />
  </svg>
)

DuplicateIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string
}

DuplicateIcon.defaultProps = {
  className: '',
  onClick: null,
  title: ''
}

export default DuplicateIcon
